<template>
  <section>
    <div class="footer__up">
      <div class='container'>
        <div class="footer__top-line line-top">
          <div class="line-top__left">
            <router-link to="/" class="footer__logo">
              <img src="/static/assets/img/footer/f-logo.svg" alt="logo" />
            </router-link>
            <div class="line-top__social social">
              <a target="_blank" href="https://vk.com/public198217496" class="social__link">
                <svg class="social__style">
                  <use xlink:href="#vk"></use>
                </svg>
              </a>
              <a target="_blank" href="https://www.youtube.com/channel/UCepcqeHOpNCpfEW3hlrkebw" class="social__link">
                <svg class="social__style" width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M13.8715 2.97046C13.8715 2.97046 13.7211 1.92866 13.3191 1.47202C12.7859 0.867725 12.1789 0.867725 11.9164 0.840381C9.95312 0.700928 7.01094 0.673584 7.01094 0.673584C7.01094 0.673584 6.27539 0.681787 5.29375 0.709131C4.31211 0.725537 3.08711 0.769287 2.10547 0.840381C1.84297 0.867725 1.23867 0.892334 0.702734 1.47202C0.276172 1.92593 0.153125 2.97046 0.153125 2.97046C0.153125 2.97046 0.0136719 4.2064 0.0136719 5.4314V6.57163C0.0136719 7.79937 0.153125 9.00796 0.153125 9.00796C0.153125 9.00796 0.300781 10.047 0.705469 10.5037C1.23867 11.108 1.94141 11.0806 2.25586 11.1599C3.36875 11.2748 7.01367 11.2994 7.01367 11.2994C7.01367 11.2994 9.95859 11.2994 11.9191 11.1326C12.1816 11.1052 12.7859 11.0806 13.3219 10.5009C13.7238 10.0443 13.8742 9.00249 13.8742 9.00249C13.8742 9.00249 14.0137 7.77476 14.0137 6.56616V5.42593C14.0137 4.20366 13.8715 2.97046 13.8715 2.97046ZM5.32109 8.78647V3.54741L9.91211 6.2271L5.32109 8.78647Z" fill="url(#paint0_linear)"/>
                  <defs>
                    <linearGradient id="paint0_linear" x1="7.01367" y1="0.673584" x2="7.01367" y2="11.2994" gradientUnits="userSpaceOnUse">
                      <stop stop-color="#3064EA"/>
                      <stop offset="1" stop-color="#314F9C"/>
                    </linearGradient>
                  </defs>
                </svg>
              </a>
              <a target="_blank" href="https://www.facebook.com/SMART%D1%8E%D1%80%D0%B8%D1%81%D1%82-109474577545896" class="social__link">
                <svg class="social__style">
                  <use xlink:href="#fb"></use>
                </svg>
              </a>
              <!--a href="#" class="social__link">
                <svg class="social__style">
                  <use xlink:href="#i"></use>
                </svg>
              </a-->
            </div>
          </div>
          <div class="line-top__right">
            <a href="tel:88001001008" class="top-line__phone">8 800 201-03-39</a>
            <a href="mailto:edu@moi-uristy.ru" class="top-line__email">edu@moi-uristy.ru</a>
          </div>
        </div>
      </div>
    </div>

    <footer class="footer">

      <div class='container'>
        <div class="footer__wrapper">

          <div class="footer-main">
            <nav class="footer-main__nav nav-footer">
              <ul class="nav-footer__list">
                <li><router-link to="/all" class="nav-footer__link">Темы и расписание</router-link></li>
                <li><router-link to="/how-it-works" class="nav-footer__link">Как это работает</router-link></li>
                <li><router-link to="/who-needs" class="nav-footer__link">Для кого этот курс</router-link></li>
                <li><router-link to="/questions" class="nav-footer__link">Вопрос-ответ</router-link></li>
                <li><router-link to="/wins" class="nav-footer__link">Выигранные дела</router-link></li>
                <li><router-link to="/job" class="nav-footer__link">Работа у нас</router-link></li>
                <li><router-link to="/otzyvy" class="nav-footer__link">Отзывы и статистика</router-link></li>
                <li><router-link to="/subscription" class="nav-footer__link">Оформить подписку</router-link></li>
              </ul>
            </nav>
            <!--div class="footer-main__link footer-link">
              <ul class="footer-link__list">
                <li><a href="#" class="footer-link__link">Заголовок публикации</a></li>
                <li><a href="#" class="footer-link__link">Пункт из новостной ленты</a></li>
                <li><a href="#" class="footer-link__link">Наименование статьи</a></li>
                <li><a href="#" class="footer-link__link">Заголовок публикации</a></li>
                <li><a href="#" class="footer-link__link">Наименование статьи</a></li>
                <li><a href="#" class="footer-link__link">Заголовок публикации</a></li>
                <li><a href="#" class="footer-link__link">Пункт из новостной ленты</a></li>
                <li><a href="#" class="footer-link__link">Наименование статьи</a></li>
                <li><a href="#" class="footer-link__link">Пункт из новостной ленты</a></li>
                <li><a href="#" class="footer-link__link">Наименование статьи</a></li>
                <li><a href="#" class="footer-link__link">Заголовок публикации</a></li>
                <li><a href="#" class="footer-link__link">Пункт из новостной ленты</a></li>
              </ul>
              <ul class="footer-link__list">
                <li><a href="#" class="footer-link__link">Заголовок публикации</a></li>
                <li><a href="#" class="footer-link__link">Пункт из новостной ленты</a></li>
                <li><a href="#" class="footer-link__link">Наименование статьи</a></li>
                <li><a href="#" class="footer-link__link">Наименование статьи</a></li>
                <li><a href="#" class="footer-link__link">Заголовок публикации</a></li>
                <li><a href="#" class="footer-link__link">Пункт из новостной ленты</a></li>
                <li><a href="#" class="footer-link__link">Пункт из новостной ленты</a></li>
                <li><a href="#" class="footer-link__link">Наименование статьи</a></li>
                <li><a href="#" class="footer-link__link">Заголовок публикации</a></li>
              </ul>
            </div-->
          </div>
          <div class="footer-down">
            <div class="footer-down__info">
              <p>Экспертный центр - некоммерческая организация АНО «ПАУ»</p>
            </div>
            <div class="footer-down__subinfo subinfo-footer">
              <h4 class="subinfo-footer__title">Наши юристы - эксперты в крупнейших СМИ страны:</h4>
              <div class="subinfo-footer__pictures">
                <img src="/static/assets/img/footer/1.png" alt="" />
                <img src="/static/assets/img/footer/2.png" alt="" />
                <img src="/static/assets/img/footer/3.png" alt="" />
                <img src="/static/assets/img/footer/4.png" alt="" />
                <img src="/static/assets/img/footer/5.png" alt="" />
                <img src="/static/assets/img/footer/6.png" alt="" />
              </div>
            </div>
            <div class="footer-down__pay pay-footer">
              <h4 class="pay-footer__title">Способы оплаты:</h4>
              <div class="pay-footer__pictures">
                <img src="/static/assets/img/footer/modul.png" alt="" />
                <img src="/static/assets/img/footer/1-2.png" alt="" />
                <img src="/static/assets/img/footer/1-3.png" alt="" />
                <img src="/static/assets/img/footer/1-4.png" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  </section>
</template>

<script>
export default {
  name: 'Footer',
  methods: {
    showModal (id) {
      this.$root.requestModal = id
    },
    backFn () {
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
    }
  }
}
</script>

<style scoped>
.column a{
    padding: 5% 0;
    cursor: pointer;
    display: block;
}
.lawyer {
    width: auto !important;
    background: unset !important;
    padding: 0 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/include/footer.vue